import {IEditor, IEditorImage, Imports} from "../editor.interfaces";


/* tslint:disable no-invalid-this */

const globalImports: Imports = typeof global !== 'undefined' ? global as any : window as any;

const fabric = globalImports.fabric || (globalImports.fabric = {});
const SF = globalImports.SF || {};
SF.Editor = SF.Editor || {} as IEditor;
globalImports.SF.Editor = globalImports.SF.Editor || {};

/**
 * This extends PhotoGroup rather than Photo because all of Photo's positioning information is relative to center
 * of group. Room for possible future improvement.
 */
globalImports.SF.Editor.Foreground = fabric.util.createClass(globalImports.SF.Editor.PhotoGroup, {
    type: 'foreground',
    hoverCursor: 'initial',
    hasControls: false,

    initialize: function(image:IEditorImage, options:any):void {
        options = options || {};

        // a foreground is always locked - no matter the data
        // options.locked = true;
        // options.fixed = true;

        this.callSuper('initialize', image, null, options);
    }
});